import AudiImage from "./teams_assets/Audi.png";
import AlpineImage from "./teams_assets/Alpine.png";
import AstonMartinImage from "./teams_assets/AstonMartin.png";
import CadillacImage from "./teams_assets/Cadillac.png";
import FerrariImage from "./teams_assets/Ferrari.png";
import HaasImage from "./teams_assets/HaasF1.png";
import McLarenImage from "./teams_assets/McLaren.png";
import MercedesImage from "./teams_assets/Mercedes.png";
import RacingBullsImage from "./teams_assets/RacingBulls.png";
import RedBullImage from "./teams_assets/Redbull.png";
import WilliamsImage from "./teams_assets/Williams.png";

const TEAM_WALL_VISUALS = {
    audi: {
        hero: AudiImage,
        badge: "Garage 09",
        signal: "Factory channel synced",
        logo: "AUDI",
        monogram: "AU",
    },
    alpine: {
        hero: AlpineImage,
        badge: "Garage 10",
        signal: "Blue line stabilized",
        logo: "ALPINE",
        monogram: "AP",
    },
    "aston-martin": {
        hero: AstonMartinImage,
        badge: "Garage 05",
        signal: "Green sector online",
        logo: "ASTON MARTIN",
        monogram: "AM",
    },
    cadillac: {
        hero: CadillacImage,
        badge: "Garage 10",
        signal: "American entry armed",
        logo: "CADILLAC",
        monogram: "CD",
    },
    ferrari: {
        hero: FerrariImage,
        badge: "Garage 02",
        signal: "Scarlet channel armed",
        logo: "FERRARI",
        monogram: "SF",
    },
    haas: {
        hero: HaasImage,
        badge: "Garage 08",
        signal: "Steel telemetry live",
        logo: "HAAS",
        monogram: "HF",
    },
    mclaren: {
        hero: McLarenImage,
        badge: "Garage 01",
        signal: "Papaya sweep active",
        logo: "McLAREN",
        monogram: "ML",
    },
    mercedes: {
        hero: MercedesImage,
        badge: "Garage 04",
        signal: "Silver stream synced",
        logo: "MERCEDES",
        monogram: "ME",
    },
    "racing-bulls": {
        hero: RacingBullsImage,
        badge: "Garage 09",
        signal: "RB feed calibrated",
        logo: "RACING BULLS",
        monogram: "RB",
    },
    "red-bull-racing": {
        hero: RedBullImage,
        badge: "Garage 03",
        signal: "Energy loop primed",
        logo: "RED BULL",
        monogram: "RB",
    },
    williams: {
        hero: WilliamsImage,
        badge: "Garage 06",
        signal: "Atlantic pulse live",
        logo: "WILLIAMS",
        monogram: "WL",
    },
};

TEAM_WALL_VISUALS.aston_martin = TEAM_WALL_VISUALS["aston-martin"];
TEAM_WALL_VISUALS.red_bull = TEAM_WALL_VISUALS["red-bull-racing"];
TEAM_WALL_VISUALS.rb = TEAM_WALL_VISUALS["racing-bulls"];

export function getTeamWallVisual(team) {
    return (
        TEAM_WALL_VISUALS[team?.id] || {
            hero: null,
            badge: "Garage 11",
            signal: "Archive panel standby",
            logo: String(team?.short_name || team?.name || "TEAM").toUpperCase(),
            monogram: String(team?.short_name || team?.name || "TM")
                .split(" ")
                .map((part) => part[0] || "")
                .join("")
                .slice(0, 2)
                .toUpperCase(),
        }
    );
}

export function getDriverInitials(name) {
    return String(name || "")
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase() || "")
        .join("");
}
